import { render, staticRenderFns } from "./clientDetail.vue?vue&type=template&id=0c80c090&scoped=true&"
import script from "./clientDetail.js?vue&type=script&lang=js&"
export * from "./clientDetail.js?vue&type=script&lang=js&"
import style0 from "./clientDetail.scss?vue&type=style&index=0&id=0c80c090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c80c090",
  null
  
)

export default component.exports